import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "./YouTubeVideo.module.scss";

const YouTubeVideo = ({
	className,
	style,
	videoId,
	videoTitle,
	autoPlay,
	lang,
	setVideoPlayer,
}) => {
	const videoPlayerRef = useRef();

	useEffect(() => {
		setVideoPlayer({
			pause: () => {
				videoPlayerRef.current.contentWindow.postMessage(
					'{"event":"command","func":"pauseVideo","args":""}',
					"*"
				);
			},
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [videoPlayerRef.current, setVideoPlayer]);

	return (
		<div className={cx(styles.youtubePlayer, className)} style={style}>
			<iframe
				ref={videoPlayerRef}
				src={`https://www.youtube.com/embed/${videoId}?autoplay=${
					autoPlay ? "1" : "0"
				}&hl=${lang}&rel=0&enablejsapi=1`}
				title={videoTitle}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			/>
		</div>
	);
};

YouTubeVideo.propTypes = {
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	videoId: PropTypes.string.isRequired,
	videoTitle: PropTypes.string,
	autoPlay: PropTypes.bool,
	lang: PropTypes.string,
	setVideoPlayer: PropTypes.func,
};

YouTubeVideo.defaultProps = {
	className: undefined,
	style: undefined,
	videoTitle: undefined,
	autoPlay: false,
	lang: "en",
	setVideoPlayer: () => {},
};

export default YouTubeVideo;
export { YouTubeVideo };
